<app-marine-insurance-card
  cardTitle="BENEFICIARY_DETAILS"
  [cardHint]="'MARINE_INSURANCE_BENEFICIARY_HINT' | translate"
  [cardHintTitle]="'BENEFICIARY_DETAILS' | translate"
  [isCanEdit]="true"
  (edit)="edit.emit()"
>
  <ng-container header-label *ngIf="isManagement">
    <span class="marine-insurance-quote-view-header-hint">| {{ "TAKEN_SELLER_LETTER_OF_CREDIT" | translate }}</span>
  </ng-container>

  <ng-container body>
    <div [ngClass]="{ 'marine-insurance-beneficiary-view-card-body-is-management': isManagement }">
      <app-marine-insurance-beneficiary-view-data [beneficiary]="beneficiary"></app-marine-insurance-beneficiary-view-data>
    </div>
  </ng-container>
</app-marine-insurance-card>
